import { lazy } from 'react'
import { matchRoutes } from 'react-router-dom'

/** React.lazy with an explicit, memoized preload edge for route orchestration. */
export function lazyRoute(importer) {
  let promise
  const load = () => {
    promise ??= importer()
    return promise
  }
  const Component = lazy(load)
  Component.preload = load
  return Component
}

export function preloadElement(element) {
  if (!element) return Promise.resolve()
  const preload = element.type?.preload
  if (typeof preload === 'function') return preload()
  const children = element.props?.children
  if (Array.isArray(children)) return Promise.all(children.map(preloadElement))
  if (children) return preloadElement(children)
  return Promise.resolve()
}

export function findRouteLoader(registry, pathname) {
  return matchRoutes(registry.map((entry) => ({ path: entry.path, entry })), pathname)?.at(-1)?.route.entry ?? null
}

export async function preloadFeatureEntry(entry) {
  if (!entry) return null
  const loaded = await entry.load()
  const descriptor = loaded.feature.routes.find((route) => route.path === entry.path)
  if (!descriptor) throw new Error(`feature route loader is stale: ${entry.module}:${entry.path}`)
  await preloadElement(descriptor.element)
  return loaded.feature
}

export async function preloadSettingsTab(entry) {
  if (!entry) return null
  const loaded = await entry.load()
  const descriptor = loaded.feature.settingsTabs?.find((tab) => tab.tab === entry.tab)
  if (!descriptor) throw new Error(`settings-tab loader is stale: ${entry.module}:${entry.tab}`)
  await preloadElement(descriptor.element)
  return loaded.feature
}
